import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import { Modal } from 'meinian-package/src/component'
import { Loading } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import { request } from 'meinian-package/src/utils'
import { ossImg } from 'meinian-package/src/utils/image'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import { ROLE_COMPARISON, IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import './index.less'

/**
 * @description: 灵感集转让组件
 * @return 灵感集转让的结果
 */
export default (props) => {
  const { style, className, children, onClick, inspirationId, onChange } = props
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(true)
  const [users, setUsers] = useState([])
  useEffect(() => {
    if (visible) {
      fetchUsers()
    }
  }, [visible])

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const res = await request.sget('/zhikuan/ins/inspiration/auth/cooperation-user-list', { }, 'MN_fetchAllUsers')
      setUsers(res)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }
  const transfer = (user) => {
    ModalConfirm.show({
      title: `确认转让灵感集给${user.nickName}吗？`,
      content: '转让后你将退出该灵感集',
      onOk: () => {
        confirmTransfer(user)
        setVisible(false)
      } })
  }
  const confirmTransfer = async (user) => {
    try {
      const res = await request.get('/ins/inspiration/auth/transfer-inspiration', { params: { inspirationId, userId: user.userId } })
      if (res) {
        message.success('转让成功')
        onChange?.({ id: inspirationId })
      }
    } catch (error) {
      console.error(error)
    }
  }
  const onClickTrigger = (e) => {
    e && e.stopPropagation()
    setVisible(true)
    onClick?.()
  }
  return <div>
    <span onClick={onClickTrigger}>{children || '转让灵感集'}</span>
    <Modal
      title="请选择转让对象"
      visible={visible}
      onCancel={() => setVisible(false)}
      hiddenFooter
      style={style}
      className={className}
    >
      <Loading spinning={loading}>
        <div className="mn-modal-transfer-wrap">
          {users?.length > 0 && users.filter(item => item.role !== IDEA_MASS_ROLE.OWNER)?.map(item => <div className="user-item">
            <div className="item-left">
              <div className="user-img" style={{ background: `url(${ossImg(item?.avatar, 40)}) center/cover no-repeat` }} />
              <div className="user-info">
                <div className="user-name">{item.nickName}</div>
                <div className="user-role">{ROLE_COMPARISON[item.role]}</div>
              </div>
            </div>
            <div className="item-right">
              <Button type="primary" style={{ width: 62 }} onClick={() => transfer(item)}>转让</Button>
            </div>
          </div>)}
        </div>
      </Loading>
    </Modal>
  </div>
}
